export default __webpack_public_path__ + "static/media/me-atualizado-sem-fundo.cc0e0c4c.png";